export default __webpack_public_path__ + "static/media/album-3.e413030c.jpg";